









































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import LinkVariantIcon from 'vue-material-design-icons/LinkVariant.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import KnowledgeAssociation from '@/components/knowledge/KnowledgeAssociation.vue';
import Header from '@/components/Header.vue';

export default Vue.extend({
  components: {
    Content,
    pxCard,
    pxButton,
    Pagination,
    Loading,
    ArrowRightIcon,
    TrashCanOutlineIcon,
    LinkVariantIcon,
    KnowledgeAssociation,
    Header,
  },

  data() {
    return {
      currentPage: 0,
      loaded: true,
      searchArticleContent: '',
      searchingArticleByContent: false,
      searchingArticlesByTreeKnowledge: false,
    };
  },

  computed: {
    ...mapGetters({
      articles: 'articles',
    }),
    ...mapState({
      treeKnowledges: (state: any) => state.treeKnowledges.knowledges,
    }),
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/explicacoes`);
    }
    this.loaded = false;
    await this.$store.dispatch('PULL_ARTICLES', {
      searchArticleContent: this.searchArticleContent,
      currentPage: this.currentPage,
    });
    this.loaded = true;
  },

  methods: {
    removeArticle: async function(articleId: number, index: number) {
      if (
        confirm(
          'Tem certeza que deseja deletar essa explicação? Ela não poderá ser recuperada!',
        )
      ) {
        let response = await this.$store.dispatch('REMOVE_ARTICLE', articleId);
        if (response === true) {
          this.$store.commit('REMOVE_ARTICLE', index);
        } else {
          //TODO analyze the error
          alert(
            'Essa explicação não pode ser deletada pois está em alguma lista',
          );
        }
      }
    },

    changePage: async function(event: any) {
      this.currentPage = event;
      this.loaded = false;
      await this.$store.dispatch('PULL_ARTICLES', {
        searchArticleContent: this.searchArticleContent,
        currentPage: this.currentPage,
      });
      this.loaded = true;
      this.$router.push(`/explicacoes/${this.currentPage + 1}`);
    },

    searchArticleByContent: async function() {
      if (this.searchArticleContent.length > 0) {
        this.currentPage = 0;
        this.$router.replace(`/explicacoes`);
        let searchArticleContent = this.searchArticleContent;
        this.searchingArticleByContent = true;
        await this.$store.dispatch('PULL_ARTICLES', {
          searchArticleContent,
          currentPage: this.currentPage,
        });
        this.searchingArticleByContent = false;
      }
    },

    async searchArticleByTreeKnowledge() {
      this.loaded = false;
      this.searchingArticlesByTreeKnowledge = true;

      if (this.treeKnowledges.length > 0) {
        await this.$store.dispatch(
          'PULL_ARTICLES_BY_TREE_KNOWLEDGES',
          this.treeKnowledges,
        );
      } else {
        await this.$store.dispatch('PULL_ARTICLES', {
          searchArticleContent: this.searchArticleContent,
          currentPage: this.currentPage,
        });
      }

      this.searchingArticlesByTreeKnowledge = false;
      this.loaded = true;
    },
  },
});
